export enum AuthTypes {
  'LOGIN_REQUEST' = '@auth/LOGIN_REQUEST',
  'LOGIN_SUCCESS' = '@auth/LOGIN_SUCCESS',
  'LOGIN_FAILURE' = '@auth/LOGIN_FAILURE',

  'UPDATE_REQUEST' = '@auth/UPDATE_REQUEST',
  'UPDATE_SUCCESS' = '@auth/UPDATE_SUCCESS',
  'UPDATE_FAILURE' = '@auth/UPDATE_FAILURE',

  'PASSWORD_REQUEST' = '@auth/PASSWORD_REQUEST',
  'PASSWORD_SUCCESS' = '@auth/PASSWORD_SUCCESS',
  'PASSWORD_FAILURE' = '@auth/PASSWORD_FAILURE',

  'PASSWORDRESET_REQUEST' = '@auth/PASSWORDRESET_REQUEST',
  'PASSWORDRESET_SUCCESS' = '@auth/PASSWORDRESET_SUCCESS',
  'PASSWORDRESET_FAILURE' = '@auth/PASSWORDRESET_FAILURE',

  'LOGOUT_REQUEST' = '@auth/LOGOUT_REQUEST',
  'LOGOUT_SUCCESS' = '@auth/LOGOUT_SUCCESS',
  'LOGOUT_FAILURE' = '@auth/LOGOUT_FAILURE',

  'INSC_SELECT' = '@auth/INSC_SELECT',

  'CDD_SELECT' = '@auth/CDD_SELECT',

  'CLEAN_STATE' = '@auth/CLEAN_STATE',

  'UPDATE_PROFILE' = '@auth/UPDATE_PROFILE',
  'UPDATE_PROFILE_SUCCESS' = '@auth/UPDATE_PROFILE_SUCCESS',

  'DEP_SELECT' = '@auth/DEP_SELECT',
}

export enum Profile {
  depositante = 'D',
  fornecedor = 'F',
  admin = 'A',
  transportadora = 'T',
  analistacd = 'ANCD',
}
export interface PartnerAuth {
  codParc?: number;
  codContato?: number;
}

export interface Auth {
  usuario: string;
  senha: string;
}

export interface User {
  nome: string;
  inscricoesEstaduais?: InscricaoEstadual[];
  depositantes?: Depositantes[];
  master: boolean;
  masterEditar: boolean;
  masterIncluir: boolean;
  isPossibleNewEmptyColect: boolean;
  email: string;
  perfil: Profile;
  centroDistribuicao: CentroDistribuicao[];
}
export interface CentroDistribuicao {
  codCdd: number;
  nomeFantasia: string;
  centroDistribuicao: string;
  contato?: string;
  editaAgendamentoDoDia: boolean;
  incluiAgendamentoNoDia?:boolean;
}

export interface Enderecos {
  bairro: string;
  cep: string;
  cidade: string;
  codBairro: number;
  codCidade: number;
  codEndereco: number;
  codUf: number;
  complemento: string;
  nomeEndereco: string;
  numEndereco: string;
  tipoEndereco: string;
  uf: string;
}

export interface InscricaoEstadual {
  codParceiro: number;
  nomeParceiro: string;
  isFavorito: boolean;
  razaoSocial: string;
  inscricaoEstadual: string;
  cnpjcpf: string;
  endereco: Enderecos[] | any;
  entregaSemNota: boolean;
}

export interface Depositantes {
  codDepositante: number;
  nome: string;
  inscricoesEstaduais: InscricaoEstadual[];
  centroDistribuicao: CentroDistribuicao[];
}

export interface handleUpdateProfileProps {
  nome: string;
  novaSenha?: string;
  senha?: string;
  inscricoesEstaduais?: InscricaoEstadual[];
  depositantes?: Depositantes[];
  email?: string;
  master?: boolean;
  perfil?: Profile;
  centroDistribuicao?: CentroDistribuicao[];
}

export interface AuthState {
  readonly token: string;
  readonly forgotPasswordMessage: '';
  readonly loginLoading: boolean;
  readonly loginError: boolean;
  readonly passwordLoading: boolean;
  readonly passwordError: boolean;
  readonly passwordResetLoading: boolean;
  readonly passwordResetError: boolean;
  readonly errorMessage: string;
  readonly user?: User;
  readonly logoutLoading: boolean;
  readonly logoutError: boolean;
  readonly inscricaoAtiva?: InscricaoEstadual | any;
  readonly cddAtivo?: CentroDistribuicao;
  readonly depositanteAtiva?: Depositantes;
}
